  // Fallback debounce (use your theme’s debounce if already defined)
  window.debounce = window.debounce || function(fn, wait = 200) {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
  };

  if (!customElements.get('media-gallery')) {
    customElements.define(
      'media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            liveRegion:   this.querySelector('[id^="GalleryStatus"]'),
            viewer:       this.querySelector('[id^="GalleryViewer"]'),
            thumbnails:   this.querySelector('[id^="GalleryThumbnails"]'),
          };

          this.mql = window.matchMedia('(min-width: 750px)');
          if (!this.elements.thumbnails || !this.elements.viewer) return;

          // Slide event from viewer
          this.elements.viewer.addEventListener(
            'slideChanged',
            debounce(this.onSlideChanged.bind(this), 300)
          );

          // Thumb clicks → set active media & scroll viewer
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            const btn = mediaToSwitch.querySelector('button');
            if (!btn) return;
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.setActiveMedia(mediaToSwitch.dataset.target, false);
            });
          });

          if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
            this.removeListSemantic();
          }

          this.setupViewerObserver();
        }

        // Detect if thumbs are vertical (column layout)
        isVerticalThumbs() {
          if (this.elements.thumbnails.classList.contains('thumbs--vertical')) return true;
          const list =
            this.elements.thumbnails.querySelector('.thumbnail-list') ||
            this.elements.thumbnails;
          const dir = list ? getComputedStyle(list).flexDirection : '';
          return this.mql.matches && /column/i.test(dir);
        }

        // Viewer → update active thumbnail
        onSlideChanged(event) {
          const id = event.detail?.currentElement?.dataset?.mediaId;
          if (!id) return;
          const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${CSS.escape(id)}"]`);
          this.setActiveThumbnail(thumbnail);
        }

        // Scroll viewer to a specific media (centered)
        scrollViewerToMedia(activeMedia) {
          
          if (!activeMedia) return;
          const scroller = this.elements.viewer.slider || activeMedia.parentElement;

          
          if (scroller.closest('.product-popup-modal__content-info' ) && window.innerWidth >= 990) {
            const top = activeMedia.offsetTop - (scroller.clientHeight - activeMedia.clientHeight) / 2;
            scroller.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
            } else {
            const left = activeMedia.offsetLeft - (scroller.clientWidth - activeMedia.clientWidth) / 2;
                        scroller.scrollTo({ left: Math.max(left, 0), behavior: 'smooth' });
            }
           
         
        }

        // Set active media in viewer
        setActiveMedia(mediaId, prepend) {
          const activeMedia =
            this.elements.viewer.querySelector(`[data-media-id="${CSS.escape(mediaId)}"]`) ||
            this.elements.viewer.querySelector('[data-media-id]');
          if (!activeMedia) return;

          this.elements.viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
          activeMedia.classList.add('is-active');
          
          if (prepend) {
            if (activeMedia.parentElement.firstChild !== activeMedia) {
              activeMedia.parentElement.prepend(activeMedia);
            }
            if (this.elements.thumbnails) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${CSS.escape(mediaId)}"]`);
              if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
                activeThumbnail.parentElement.prepend(activeThumbnail);
              }
            }
            this.elements.viewer.slider?.resetPages?.();
          }

          this.preventStickyHeader();

          // Scroll viewer to the new active slide
          this.scrollViewerToMedia(activeMedia);

          this.playActiveMedia(activeMedia);

          if (!this.elements.thumbnails) return;
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${CSS.escape(mediaId)}"]`);
          this.setActiveThumbnail(activeThumbnail);

          this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition);
        }

        // Mark thumbnail active + scroll thumbs list if needed
        setActiveThumbnail(thumbnail) {
          if (!this.elements.thumbnails || !thumbnail) return;

          this.elements.thumbnails.querySelectorAll('button').forEach(btn => btn.removeAttribute('aria-current'));
          thumbnail.querySelector('button')?.setAttribute('aria-current', 'true');

          const vertical = this.isVerticalThumbs();
          const scroller = this.elements.thumbnails.slider || this.elements.thumbnails;

          if (!vertical && typeof this.elements.thumbnails.isSlideVisible === 'function') {
            if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
            scroller.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
            return;
          }

          if (vertical) {
            const top = thumbnail.offsetTop;
            const bottom = top + thumbnail.offsetHeight;
            const viewTop = scroller.scrollTop;
            const viewBottom = viewTop + scroller.clientHeight;
            if (top < viewTop || bottom > viewBottom) {
              scroller.scrollTo({ top: Math.max(top - 8, 0), behavior: 'smooth' });
            }
          } else {
            const left = thumbnail.offsetLeft;
            const right = left + thumbnail.offsetWidth;
            const viewLeft = scroller.scrollLeft;
            const viewRight = viewLeft + scroller.clientWidth;
            if (left < viewLeft || right > viewRight) {
              scroller.scrollTo({ left: Math.max(left - 8, 0), behavior: 'smooth' });
            }
          }
        }

        announceLiveRegion(activeItem, position) {
          const image = activeItem.querySelector('.product__modal-opener--image img');
          if (!image || !this.elements.liveRegion) return;
          image.onload = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'false');
            this.elements.liveRegion.innerHTML =
              (window.accessibilityStrings?.imageAvailable || 'Image [index] available')
                .replace('[index]', position || '');
            setTimeout(() => this.elements.liveRegion.setAttribute('aria-hidden', 'true'), 2000);
          };
          image.src = image.src;
        }

        playActiveMedia(activeItem) {
          window.pauseAllMedia?.();
          const deferred = activeItem.querySelector('.deferred-media');
          if (deferred?.loadContent) deferred.loadContent(false);
        }

        preventStickyHeader() {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }

        removeListSemantic() {
          if (!this.elements.viewer.slider) return;
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this.elements.viewer.sliderItems?.forEach?.((slide) => slide.setAttribute('role', 'presentation'));
        }

        // Observer: sync thumbs when slides enter view
        setupViewerObserver() {
          const items = this.elements.viewer.querySelectorAll('[data-media-id]');
          if (!items.length) return;

          const rootEl = this.elements.viewer;
          this.viewerIO?.disconnect?.();
          this.viewerIO = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const mediaId = entry.target.dataset.mediaId;
              const thumb = this.elements.thumbnails.querySelector(`[data-target="${CSS.escape(mediaId)}"]`);
              this.setActiveThumbnail(thumb);
            });
          }, { root: rootEl, threshold: 0.9 });

          items.forEach(el => this.viewerIO.observe(el));
        }
      }
    );
  }
